import { format0 } from '../../utils/number';

interface FormattedCountProps {
  value: number | null | undefined;
  fallback?: string;
}

/**
 * Displays an integer/count value with thousand separators (commas).
 *
 * Use this component whenever displaying counts, totals, or integer values
 * that could exceed 999. Never render numeric values directly in JSX.
 *
 * @param {FormattedCountProps} props - Component props
 * @param {number | null | undefined} props.value - The numeric value to format
 * @param {string} props.fallback - Fallback string for null/undefined values (default: '--')
 * @return {JSX.Element} A React fragment containing the formatted number string
 *
 * @example
 * // GOOD - always use FormattedCount for counts/integers
 * <FormattedCount value={totalSlots} />
 * <FormattedCount value={count} fallback="N/A" />
 *
 * // BAD - never render numbers directly
 * <div>{totalSlots}</div>
 * <span>{count}</span>
 */
export const FormattedCount = ({
  value,
  fallback = '--',
}: FormattedCountProps) => <>{format0(value, fallback)}</>;
